import { ShortWeekdayType } from '../Power/IPower';

export enum TimerType {
	TIMER_1 = 0,
	TIMER_2 = 1,
	TIMER_3 = 2,
	TIMER_4 = 3,
	TIMER_5 = 4,
	TIMER_6 = 5,
	TIMER_7 = 6,
}

// TODO: remove in the next major release
/** @deprecated use ShortWeekdayType instead */
export enum TimerWeekday {
	sun = 0,
	mon = 1,
	tue = 2,
	wed = 3,
	thu = 4,
	fri = 5,
	sat = 6,
}

export interface ITimer {
	type: keyof typeof TimerType;
	timeOn: string | null;
	timeOff: string | null;
	weekdays: ShortWeekdayType[];
	volume: number;
}
